import { Injectable } from '@angular/core';
import { ScriptLoaderService, ScriptModel } from '../../core/services/scriptloader.service';
import { PlatformInformationService } from '../../../../projects/platform-manager/src/public_api';
import { TranslateService } from '@ngx-translate/core';
import { Observable, switchMap } from 'rxjs';
import { CurrencyService } from '../../core/services/currency.service';

export enum MentionMeSituation {
  confirmation = 'confirmation',
  booking = 'booking',
  landingpage = 'landingpage',
  checkout = 'checkout'
}

export enum MentionMeType {
  referreroffer = 'referreroffer',
  refereefind = 'refereefind'
}

export interface MentionMeInterface {
  situation: MentionMeSituation;
  calltoactionurl?: string;
  email?: string;
  order_number?: string;
  order_subtotal?: number;
  firstname?: string;
  surname?: string;
}

@Injectable({
  providedIn: 'root'
})
export class MentionMeService {
  constructor(
    private scriptLoaderService: ScriptLoaderService,
    private platformInformationService: PlatformInformationService,
    private translateService: TranslateService,
    private currencyService: CurrencyService
  ) {}

  loadMentionMeScript(data: MentionMeInterface, type: MentionMeType): Observable<ScriptModel> {
    return this.platformInformationService.customerCountryCode$.pipe(
      switchMap(countryCode => {
        let src = `${this.platformInformationService.getApiEndpointFor('mentionMeURL')}/${type}/mmd80e0e0b?situation=${data.situation}&locale=${encodeURIComponent(this.translateService.currentLang + '_' + countryCode)}&order_currency=${encodeURIComponent(this.currencyService.getActualCurrency())}`;

        if (data.calltoactionurl) {
          src += `&calltoactionurl=${encodeURIComponent(data.calltoactionurl)}`;
        }
        if (data.email) {
          src += `&email=${encodeURIComponent(data.email)}`;
        }
        if (data.firstname) {
          src += `&firstname=${encodeURIComponent(data.firstname)}`;
        }
        if (data.surname) {
          src += `&surname=${encodeURIComponent(data.surname)}`;
        }
        if (data.order_number) {
          src += `&order_number=${encodeURIComponent(data.order_number)}`;
        }
        if (data.order_subtotal) {
          src += `&order_subtotal=${encodeURIComponent(data.order_subtotal)}`;
        }

        return this.scriptLoaderService.load({
          name: `mentionMe`,
          src,
          loaded: false,
          skipLoadCheck: true
        });
      })
    );
  }
}
